/// <reference path="./vite-env.d.ts" />
import {
    QueryClient,
    QueryClientProvider,
} from "@tanstack/react-query";
import {
    render,
} from "preact";
import {
    Toaster,
} from "react-hot-toast";
import App from "./App.tsx";
import "./styles/globals.css";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60,
            retry: 1,
        },
    },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("root element not found");
}
render(
    <QueryClientProvider client={queryClient}>
        <App />
        <Toaster
            position="bottom-right"
            toastOptions={{
                duration: 3000,
                style: {
                    background: "#252525",
                    color: "#ffffff",
                    border: "1px solid #333333",
                },
                success: {
                    iconTheme: {
                        primary: "#4caf50",
                        secondary: "#ffffff",
                    },
                },
                error: {
                    iconTheme: {
                        primary: "#f44336",
                        secondary: "#ffffff",
                    },
                },
            }}
        />
    </QueryClientProvider>,
    rootElement,
);
